import { gql } from "graphql-request";

export const READ_DEPARTMENT_BY_ID = gql`
  query ReadDepartmentById($id: ID!) {
    readDepartmentById(id: $id) {
      id
      tenantId
      name
      description
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_DEPARTMENTS_BY_TENANT = gql`
  query ReadDepartmentsByTenant($tenantId: ID!) {
    readDepartmentsByTenant(tenantId: $tenantId) {
      id
      tenantId
      name
      description
      createdAt
      updatedAt
      archivedAt
    }
  }
`;